module.exports = __webpack_public_path__ + "static/Profile-Zach_v1-9be453d77e24376a85c1118ca2e319af.svg";